import { render, staticRenderFns } from "./CommissionPlanList.vue?vue&type=template&id=ec308f70&"
import script from "./CommissionPlanList.vue?vue&type=script&lang=js&"
export * from "./CommissionPlanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports